import React from "react";


interface UploadPreviewFileProps {
    id?: number;
    image?: string;
    position?: number;
    progress?: number;
    error?: string;
    preview?: string;
    index: number;
    disableRemoveButton?: boolean;
    hideMoveButton?: boolean;
    removeFile: (file: any) => void;
}

export const UploadPreviewFile: React.FC<UploadPreviewFileProps> = (
    props) => {


    const {
        index,
        removeFile,
        preview,
        progress,
        error,
        id,
        disableRemoveButton = false,
        hideMoveButton = false,
    } = props;


    const onRemoveClick = () => {
        removeFile({id, position: index, image: id});
    }

    return (
        <div className="upload__preview-file upfile"
             data-id={id}
        >
            {progress && progress < 100 && <div className="upfile__progress" style={{"--progressbar": `${progress}%`, zIndex: 2} as React.CSSProperties}></div>}
            {error ? (
                <>
                    <div className="upfile__error">
                        {error}
                        <svg role="img" className="upfile__error-ico">
                            <use href="./img/sprite.svg#attention"></use>
                        </svg>
                    </div>
                    <div className="upfile__btns">
                        <button
                            className="upfile__btn upfile__btn_delete"
                            type="button"
                            aria-label="Remove"
                            title="Remove"
                            onClick={onRemoveClick}
                        ></button>
                    </div>
                </>
            ) : preview ? (
                <>
                    <picture className="upfile__pic">
                        <img className="upfile__img" src={preview} alt=""/>
                    </picture>
                    {!progress && <div className="upfile__btns">
                        {!hideMoveButton && <button
                            className="upfile__btn upfile__btn_move js_sortable_handle"
                            role="button"
                            title="Move"
                            type="button"></button>}
                        {!disableRemoveButton && <button
                                className="upfile__btn upfile__btn_delete"
                                type="button"
                                aria-label="Remove"
                                title="Remove"
                                onClick={onRemoveClick}
                            ></button>}
                    </div>}
                </>
            ) : null}

        </div>
    );
};

export default UploadPreviewFile;